module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMoTnb5TwlmGDVg1IBRA4aLAQBJbhkfeZu1XwAAAABJRU5ErkJggg=="